import { FunctionComponent } from 'react';
import { Outlet } from 'react-router-dom';
import Page from 'components/common/Page';
import { ProductName } from 'domain/product/enums/ProductName';
import PageHeading from 'components/common/Product/PageHeading';
import { TopMenu } from 'components/common/Menu';
import menuConfig from './menuConfig';

const MontelPPAOutlet: FunctionComponent = () => (
	<Page>
		<PageHeading product={ProductName.MontelPPA} />
		<TopMenu menuConfig={menuConfig} />
		<Outlet />
	</Page>
);

export default MontelPPAOutlet;
